module.exports = __webpack_public_path__ + "img/triple1.17d237c0.jpg";